import React from 'react';
import { countries } from '../../lib/countries';
import { Input, PhoneInput, Select, Button } from './FormControls';
import { StepProps } from './types';

interface StepPersonalProps extends StepProps {
  onNext: () => void;
}

const StepPersonal: React.FC<StepPersonalProps> = ({ formData, onChange, onNext }) => (
  <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-500">
    <h3 className="text-2xl font-black text-gray-900">Personal Details</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Input label="First Name" value={formData.firstName} onChange={v => onChange({ firstName: v })} required />
      <Input label="Last Name" value={formData.lastName} onChange={v => onChange({ lastName: v })} required />
      <Input label="Email" type="email" value={formData.email} onChange={v => onChange({ email: v })} required />
      <PhoneInput
        label="Phone Number"
        countryCode={formData.phoneCountryCode || '+1'}
        phone={formData.phone}
        onCountryCodeChange={v => onChange({ phoneCountryCode: v })}
        onPhoneChange={v => onChange({ phone: v })}
        required
      />
      <Select label="Country" value={formData.country} onChange={v => onChange({ country: v })} options={countries} required />
      <Input label="WhatsApp Number (Optional)" type="tel" value={formData.whatsapp || ''} onChange={v => onChange({ whatsapp: v })} placeholder="N/A if no whatsapp" />
      <Input label="City" value={formData.city} onChange={v => onChange({ city: v })} required />
      <div className="space-y-2">
        <label className="block text-sm font-bold text-gray-700">Gender <span className="text-red-500">*</span></label>
        <div className="flex gap-4 pt-1">
          {['Male', 'Female'].map(opt => (
            <label key={opt} className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="gender"
                checked={formData.gender === opt}
                onChange={() => onChange({ gender: opt })}
                className="w-4 h-4 text-purple-600 focus:ring-violet-400"
              />
              <span className="text-sm font-medium text-gray-700">{opt}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
    <div className="flex justify-end pt-6">
      <Button onClick={onNext}>Next Step →</Button>
    </div>
  </div>
);

export default StepPersonal;
